module.exports = {
  label: {
    headerTitle: 'User Management',
    addHeaderTitle: 'Add User Management',
    editHeaderTitle: 'Edit User Management',
    company: 'Company',
    selectCompany: 'Select Company',
    site: 'Site',
    selectsite: 'Select Site',
    userName: 'User Name',
    password: 'Password',
    name: 'Name',
    emailAddress: 'Email Address',
    roles: 'Roles',
    receiveQuestionnaireFailsEmail: 'ReceiveQuestionnaireFailsEmail',
    receiveHighTempAlertEmail: 'ReceiveHighTempAlertEmail',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel'
    }
  }
}
